import { Component, OnInit } from '@angular/core';
import { EventService } from '../../shared/event.service';
import { Event } from 'src/app/shared/models/Event';
import { RequestedDevice } from 'src/app/shared/models/RequestedDevice';
import { RequestedCable } from 'src/app/shared/models/RequestedCable';
import { TranslateService } from '@ngx-translate/core';
import { RequestedSoftwareType } from 'src/app/shared/models/RequestedSoftwareType';
import { SoftwareType } from 'src/app/shared/models/SoftwareType';
import moment from 'moment';
import { AdditionalCost } from 'src/app/shared/models/AdditionalCost';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LOCAL_STORAGE } from "src/app/core/constants";

@Component({
    selector: 'app-general-details',
    templateUrl: './general-details.component.html',
    styleUrls: ['./general-details.component.css'],
    standalone: false
})
export class GeneralDetailsComponent implements OnInit {

  private _tokenData: any;

  public event: Event = new Event();
  public arrayDevices: RequestedDevice[];

  public requestedPhoneHardware = 0;
  public requestedPhoneSoftware = 0;
  public requestedWaiterSoftware = 0;
  public requestedCashRegisterSoftware = 0;
  public requestedMainDeviceSoftware = 0;

  public requestedTabletHardware = 0;
  public requestedTabletSoftware = 0;

  public requestedPrinterHardware = 0;
  public requestedPrinterSoftware = 0;

  public requestedFiscalPrinterHardware = 0;
  public requestedFiscalPrinterSoftware = 0;

  private _softwareTypesArray: SoftwareType[];

  public addProducts = [];
  public selectedProduct = null;
  public defaultItem: { id: number, name: string };
  public addProductsList: Array<{id: number, name: string}>;

  public canAddProducts = false;

  public additionalCosts: AdditionalCost[] = [];
  public additionalCostsArray: {id: number, name: string, title: string, type: number, quantity: number, cost: number} [] = [];

  public showQuantityError = false;

  constructor(private _eventService: EventService, private _translateService: TranslateService, private _modalService: NgbModal, private _jwtHelper: JwtHelperService) {}

  ngOnInit() {
    const accessToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN);
    this._tokenData = this._jwtHelper.decodeToken(accessToken).data;
    this._eventService.updateCurrentActiveSubPage('general');
    this._eventService.getAllSoftwareTypes().subscribe(result => {
      this._softwareTypesArray = result
    });
    this._eventService.currentEventObject.subscribe(result => {
      if (result) {
        this.event = result;
        this.event.requestedDevices.forEach(reqHardware => {
          switch (reqHardware.deviceTypes.id) {
            case 1:
              this.requestedPhoneHardware += reqHardware.quantity;
              break;
            case 2:
              this.requestedTabletHardware += reqHardware.quantity;
              break;
            case 3:
              this.requestedTabletHardware += reqHardware.quantity;
              break;
          }
        });

        this.event.requestedPrinterTypes.forEach(reqHardware => {
          if (reqHardware.printerType.isFiscalPrinter) {
            this.requestedFiscalPrinterHardware += reqHardware.quantity;
          } else {
            this.requestedPrinterHardware += reqHardware.quantity;
          }
        });

        this.event.requestedSoftwareTypes.forEach(reqSoftware => {
          switch (reqSoftware.softwareType.id) {
            case 1:
              this.requestedWaiterSoftware += reqSoftware.quantity;
              this.requestedPhoneSoftware += reqSoftware.quantity;
              break;
            case 2:
              this.requestedCashRegisterSoftware += reqSoftware.quantity;
              this.requestedPhoneSoftware += reqSoftware.quantity;
              break;
            case 3:
              this.requestedMainDeviceSoftware += reqSoftware.quantity;
              this.requestedPhoneSoftware += reqSoftware.quantity;
              break;
            case 4:
              this.requestedPrinterSoftware += reqSoftware.quantity;
              break;
            case 5:
              this.requestedFiscalPrinterSoftware += reqSoftware.quantity;
              break;
          }
        });

        this._eventService.getAdditionalCostsAssigned(this.event.id.toString()).subscribe(rs => {
          rs.forEach(rec => {
            const el = {
              id: rec.id,
              name: rec.name,
              title: this._translateService.instant('offers.request.additionalCosts.' + rec.name + '.title'),
              type: rec.type,
              quantity: rec.quantity,
              cost: rec.cost,
              requestedAt: rec.requestedAt ? moment(rec.requestedAt).format('YYYY-MM-DD HH:mm:ss') : null
            };
            this.additionalCostsArray.push(el);
          });
          this.defaultItem = {id: 0, name: this._translateService.instant('event.details.add')};
          this.addProductsList = [
            {id: 1, name: this._translateService.instant('event.details.softwareWaiter')},
            {id: 2, name: this._translateService.instant('event.details.softwareCashRegister')}
          ];
          if ((this.event.requestedSoftwareTypes.filter(s => s.softwareType.id === 3).length === 0 || this.event.requestedSoftwareTypes.filter(s => s.softwareType.id === 3)[0]?.quantity <= 0) && this.requestedWaiterSoftware + this.requestedCashRegisterSoftware <= 100) {
            this.addProductsList.push({id: 3, name: this._translateService.instant('event.details.softwareMainDevice')});
          }
          this.addProductsList.push(...[
            {id: 4, name: this._translateService.instant('event.details.softwarePrinter')},
            {id: 9, name: this._translateService.instant('offers.request.additionalCosts.vivaWallet.title')},
            {id: 10, name: this._translateService.instant('offers.request.additionalCosts.sumUp.title')},
            {id: 13, name: this._translateService.instant('offers.request.additionalCosts.worldLine.title')}
          ]);
          if (this.event.requestedSoftwareTypes.filter(s => s.softwareType.id === 3)[0]?.quantity > 0 && (this.additionalCostsArray.filter(c => c.id === 11).length === 0 || this.additionalCostsArray.filter(c => c.id === 11)[0]?.quantity <= 0)) {
            this.addProductsList.push({id: 11, name: this._translateService.instant('offers.request.additionalCosts.stockManagement.title')});
          }
        });

        this._eventService.getAdditionalCosts().subscribe(result => {
          this.additionalCosts = result;
        });

      }
    });

  }


  getGroupByDeviceUsers(deviceTypeQuantity: number, deviceTypeId: number) {
    let softwareQuantity = 0;
    this.event.requestedSoftwareTypes.forEach(reqSoftware => {
      if (reqSoftware.softwareType.id === 1 && deviceTypeId === 1) {
        softwareQuantity += reqSoftware.quantity;
      } else {
        if ((reqSoftware.softwareType.id === 2 || reqSoftware.softwareType.id === 3) && deviceTypeId === 2) {
          softwareQuantity += reqSoftware.quantity;
        }
      }
    });
    return softwareQuantity - deviceTypeQuantity;
  }

  getTotalQuantity(requestedList: any[]) {
    return requestedList.reduce((acc, curr) => acc + curr.quantity, 0);
  }

  getGroupByCables(cableList: RequestedCable[]): RequestedCable[] {
    const cables: RequestedCable[] = [];
    cableList.forEach((c) => {
      const searchCable = cables.find(cb => cb.cables.cableType.length === c.cables.cableType.length);
      if (searchCable == null) {
        cables.push(c);
      } else {
        searchCable.quantity += c.quantity;
      }
    });
    return cables;
  }

  public updateEvent() {
    const eventCopy = JSON.parse(JSON.stringify(this.event));
    eventCopy.additionalCosts = this.additionalCostsArray;
    eventCopy.eventAdditionalCosts = this.additionalCostsArray;
    const requestedDeviceUserTypes = [];
    this.addProducts.forEach(p => {
        if (p.id === 1 || p.id === 2 || p.id === 3 || p.id === 4) {
          if (eventCopy.requestedSoftwareTypes.find(r => r.softwareType.id === p.id)) {
            eventCopy.requestedSoftwareTypes.find(r => r.softwareType.id === p.id).quantity += p.quantity;
            eventCopy.requestedSoftwareTypes.find(r => r.softwareType.id === p.id).requestedAt = moment().format('YYYY-MM-DD HH:mm');
            const requestedDeviceUserType = { quantity: p.quantity, deviceUserType: { id: p.id } };
            requestedDeviceUserTypes.push(requestedDeviceUserType);
          } else {
            const reqSoftware = new RequestedSoftwareType();
            reqSoftware.quantity = p.quantity;
            reqSoftware.softwareType = this._softwareTypesArray.find(softwareType => softwareType.id === p.id);
            reqSoftware.requestedAt = moment().format('YYYY-MM-DD HH:mm');
            eventCopy.requestedSoftwareTypes.push(reqSoftware);
            const requestedDeviceUserType = { quantity: p.quantity, deviceUserType: { id: p.id } };
            requestedDeviceUserTypes.push(requestedDeviceUserType);
          }
        }
        if (p.id === 9 || p.id === 10 || p.id === 11 || p.id === 13) {
          if (eventCopy.additionalCosts.find(c => c.id === p.id)) {
            eventCopy.additionalCosts.find(c => c.id === p.id).quantity += p.quantity;
            eventCopy.additionalCosts.find(c => c.id === p.id).requestedAt = moment().format('YYYY-MM-DD HH:mm');
          } else {
            eventCopy.additionalCosts.push(this.additionalCosts.find(c => c.id === p.id));
            eventCopy.additionalCosts.find(c => c.id === p.id).quantity = p.quantity;
            eventCopy.additionalCosts.find(c => c.id === p.id).requestedAt = moment().format('YYYY-MM-DD HH:mm');
          }
          eventCopy.additionalCosts.find(c => c.id === p.id).quantityRequested = eventCopy.additionalCosts.find(c => c.id === p.id).quantity;
        }
    });
    if (eventCopy.additionalCosts.filter(c => c.id === 9)[0]?.quantity > 0) {
      eventCopy.hasVivaWallet = true;
    }
    if (eventCopy.additionalCosts.filter(c => c.id === 10)[0]?.quantity > 0) {
      eventCopy.hasSumUp = true;
    }
    if (eventCopy.additionalCosts.filter(c => c.id === 13)[0]?.quantity > 0) {
      eventCopy.hasWorldLine = true;
    }
    this.showQuantityError = false;
    if (eventCopy.requestedSoftwareTypes.filter(s => s.softwareType.id === 3)[0]?.quantity > 0 && (eventCopy.requestedSoftwareTypes.filter(s => s.softwareType.id === 1)[0]?.quantity + eventCopy.requestedSoftwareTypes.filter(s => s.softwareType.id === 2)[0]?.quantity) > 100) {
      this.showQuantityError = true;
      return;
    }
    this._eventService.updateEvent(eventCopy, true, this._tokenData.firstEmail).subscribe(res => {
      this._eventService.generateRequestedDeviceUsers(eventCopy.id, requestedDeviceUserTypes, this._translateService.currentLang).subscribe(
      res => {
        window.location.reload();
      },
      error => {
        if (error.status === 603) {
          window.location.reload();
        }
      });
    });
  }

  public getFilteredProducts() {
    if (this.addProductsList) {
      return this.addProductsList.filter(p => !this.addProducts.map(a => a.id).includes(p.id));
    }
    return [];
  }

  public onProductSelected(event) {
    if (event.id !== 0) {
      this.addProducts.push({ id: event.id, name: event.name, quantity: event.id === 3 || event.id === 11 ? 1 : 0 });
      if (event.id === 3) {
        this.canAddProducts = true;
        this.addProductsList.push({id: 11, name: this._translateService.instant('offers.request.additionalCosts.stockManagement.title')});
      }
      if (event.id === 11) {
        this.canAddProducts = true;
      }
    }
    setTimeout(() => {
      this.selectedProduct = this.defaultItem;
    }, 10);
  }

  public onProductQuantityChange() {
    this.checkCanAddProducts();
  }

  private checkCanAddProducts() {
    this.canAddProducts = false;
    this.addProducts.forEach(p => {
      if (p.quantity > 0) {
        this.canAddProducts = true;
      }
    })
  }

  public removeProduct(product) {
    this.addProducts = this.addProducts.filter(p => p.id !== product.id);
    if (product.id === 3) {
      this.addProductsList = this.addProductsList.filter(p => p.id !== 11);
      this.addProducts = this.addProducts.filter(p => p.id !== 11);
    }
    this.checkCanAddProducts();
  }

  public openAddModal(modal) {
    this._modalService.open(modal).result.then(result => {
      this.updateEvent();
    });
  }

}
